<template>
  <v-dialog v-model="showRedAlert" persistent eager width="500" dark>
    <v-card dark eager id="redalertpopup">
      <v-card-title>Emergency Alert</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <img src="/img/RedAlert.gif" style="width:200px" />
          </v-col>
          <v-col>
            <audio id="redAlertSound" src="/sounds/tos-redalert.mp3" />
            <h3>{{label}}</h3>
            {{text}}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center">
        <v-btn color="primary" @click="onAcknowledge">Acknowledge</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Trimaster from "@/plugins/servers/trimaster.js";
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/event-bus.js";

export default {
  name: "",
  props: ["value"],
  components: {},
  beforeMount() {},
  mounted() {
    EventBus.$on('facility-websocket-message', this.handleMessage)
  },
  data() {
    return {
      showRedAlert: false,
      intervalHandler: null,
      label: null,
      text: null,
      alert_id: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    playSound() {
      document.getElementById("redAlertSound").currentTime = 0;
      document.getElementById("redAlertSound").play();
      this.intervalCounter++;
      if (this.intervalCounter > 3) {
        clearInterval(this.intervalHandler);
      }
    },
    onAcknowledge() {
      this.showRedAlert = false;

      Trimaster.post("redAlertAcknowledgements", this.getUser.apitoken, {
        user_id: this.getUser.id,
        redAlert_id: this.alert_id,
      });

      let player = document.getElementById("redAlertSound");

      this.intervalCounter = 4;
      clearInterval(this.intervalHandler);
      player.pause();
    },
    handleMessage(message) {
      if (message.type && message.type === 'redAlert') {
        if (
            message.payload.data.facility_id === this.getUser.facility_id &&
            (message.payload.type === "create" || message.payload.type === "update")
        ) {
          this.intervalCounter = 0;
          this.intervalHandler = setInterval(this.playSound, 2000);
          this.label = message.payload.data.label;
          this.text = message.payload.data.text;
          this.showRedAlert = true;
          this.alert_id = message.payload.data.id;
        }
      }
    }
  },
};
</script>
<style>
#redalertpopup {
  background-color: #000000;
}
</style>

